import styled from "styled-components";

export const CollaborationContainer = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 10px;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const CardImg = styled.img`
  width: 300px;
  height: 200px;
  border-radius: 5px 0 0 5px;
  object-fit: contain;
`;

export const CardBody = styled.div`
  text-align: center;
  width: 100%;
  margin: 2px 16px;
`;
